import { useMagasinStore } from "@/store/magasin";
import ShopPageCodes from "@/utils/fiche-magasin-codes";
import { pushProps, usePush } from "../mixins/push-mixin";


export const pageFicheMagasinProps = () => ({
  prospectus: {
    type: Array,
    required: true
  },
  fuel: {
    type: Object,
    required: false,
    default: () => []
  },
  magasin: {
    type: Object,
    required: false,
    default: () => []
  },
  attachedShopId: {
    type: Number,
    required: false,
    default: 0
  },
  isPro: {
    type: Boolean,
    required: false,
    default: false
  },
  isFlocklerLoaded: {
    type: Boolean,
    required: false,
    default: false
  },
  articles: {
    type: Array,
    required: true
  },
  ...pushProps()
})

export const pageFicheMagasinEmits = () => ([
  "chooseShopClicked"
])

export const usePageFicheMagasin = (props, context, traiteurFeteRef, traiteurPermanentRef) => {

  const { getPushData, getPushList, getPushTitle } = usePush(props.pushZones);
  const magasinStore = useMagasinStore()
  const route = useRoute();

  const maxServices = ref(2)
  const showWithdrawalPoints = ref(false)
  const withdrawalPoints = ref([])
  const showPlanningClickCollect = ref(false)
  const showPlanningClickCollectTraiteur = ref(false)
  const showPlanningClickCollectTraiteurNoel = ref(false)

  const { isNational } = storeToRefs(magasinStore)

  const itineraire = computed(() => {
    const itineraireUrl = 'https://www.google.fr/maps/dir//'
    return props.magasin.attributes.latitude && props.magasin.attributes.longitude ? itineraireUrl + props.magasin.attributes.latitude + ',' + props.magasin.attributes.longitude : ''
  })
  const exceptionalOpening = computed(() => {
    const exceptionalDays = props.magasin.attributes.horaires_exceptionnels_table ? props.magasin.attributes.horaires_exceptionnels_table.find(e => e.type === "Magasin") : []
    return exceptionalDays && exceptionalDays.horaires.filter(e => e.type === "Ouverture")
  })
  const exceptionalClosure = computed(() => {
    const exceptionalDays = props.magasin.attributes.horaires_exceptionnels_table ? props.magasin.attributes.horaires_exceptionnels_table.find(e => e.type === "Magasin") : []
    return exceptionalDays && exceptionalDays.horaires.filter(e => e.type === "Fermeture")
  })
  const shopTimetable = computed(() => {
    const shopTimetable = props.magasin.attributes.horaires_table && props.magasin.attributes.horaires_table.find(e => e.type === "Magasin")
    return shopTimetable
  })
  const positions = computed(() => {
    const positions = [
      {
        lat: props.magasin.attributes.latitude ? props.magasin.attributes.latitude : 0,
        lng: props.magasin.attributes.longitude ? props.magasin.attributes.longitude : 0
      }]
    return positions;
  })

  const isFuelAvailable = computed(() => {
    return !!props.fuel?.find((el) => el.attributes.libelle === "Fioul")
  })

  const modesDeCommande = computed(() => {
    return props.magasin.attributes.modes_commande.filter(mode => mode.type !== "LDD")
  })

  const changeShop = (storeId) => {
    context.emit("chooseShopClicked", storeId);
  }
  const toggleWithdrawalPoints = (points) => {
    withdrawalPoints.value = points
    showWithdrawalPoints.value = !showWithdrawalPoints.value
  }
  const togglePlanningTabClickCollect = () => {
    showPlanningClickCollect.value = !showPlanningClickCollect.value
  }
  const togglePlanningTabClickCollectTraiteur = () => {
    showPlanningClickCollectTraiteur.value = !showPlanningClickCollectTraiteur.value
  }
  const togglePlanningTabClickCollectTraiteurNoel = () => {
    showPlanningClickCollectTraiteurNoel.value = !showPlanningClickCollectTraiteurNoel.value
  }
  const closeWithdrawalPopin = () => {
    withdrawalPoints.value = []
    showWithdrawalPoints.value = false
  }
  const displayAllServices = () => {
    if (maxServices.value === 2) {
      maxServices.value = props.magasin.attributes.services.length
    } else {
      maxServices.value = 2
    }
  }

  const mounted = async () => {
    await nextTick(() => {
      if (route.query && route.query.show_plan) {
        const mdcClickAndCollect = props.magasin.attributes.modes_commande && props.magasin.attributes.modes_commande.find(e => e.type === "CC")
        const mdcClickAndCollectTraiteur = props.magasin.attributes.modes_commande && props.magasin.attributes.modes_commande.find(e => e.type === "CC_TRAITEUR_NOEL")
        const mdcClickAndCollectTraiteurPermanent = props.magasin.attributes.modes_commande && props.magasin.attributes.modes_commande.find(e => e.type === "CC_TRAITEUR_PERMANENT")
        if (route.query.show_plan === 'ccn' && mdcClickAndCollect) {
          showPlanningClickCollect.value = true;
        }
        if (route.query.show_plan === 'cct' && mdcClickAndCollectTraiteur) {
          traiteurFeteRef.value.show()
        }
        if (route.query.show_plan === 'ccp' && mdcClickAndCollectTraiteurPermanent) {
          traiteurPermanentRef.value.show()
        }
      }
    });
  }

  return {
    isFuelAvailable,
    maxServices,
    showWithdrawalPoints,
    withdrawalPoints,
    showPlanningClickCollect,
    showPlanningClickCollectTraiteur,
    showPlanningClickCollectTraiteurNoel,
    isNational,
    itineraire,
    exceptionalOpening,
    exceptionalClosure,
    shopTimetable,
    positions,
    modesDeCommande,
    changeShop,
    toggleWithdrawalPoints,
    togglePlanningTabClickCollect,
    togglePlanningTabClickCollectTraiteur,
    togglePlanningTabClickCollectTraiteurNoel,
    closeWithdrawalPopin,
    displayAllServices,
    getPushData,
    getPushList,
    getPushTitle,
    mounted,
    ShopPageCodes
  }


}